// Sync quantity between main product form and sticky add to cart
document.addEventListener('DOMContentLoaded', function() {
    // Function to sync quantity values
    function syncQuantityToSticky() {
        // Get quantity from main product form
        const mainQuantityInput = document.querySelector('.pvGroup-row .quantity__input, .productView-form .quantity__input');
        
        if (mainQuantityInput) {
            // Get sticky cart quantity inputs
            const stickyQuantityInputs = document.querySelectorAll('.productView-stickyCart .quantity__input');
            const stickyHiddenInput = document.querySelector('#product-form-sticky-' + mainQuantityInput.dataset.product + ' input[name="quantity"]');
            
            // Update all sticky quantity inputs
            stickyQuantityInputs.forEach(input => {
                input.value = mainQuantityInput.value;
            });
            
            // If there's a hidden quantity input in sticky form, update it too
            if (stickyHiddenInput) {
                stickyHiddenInput.value = mainQuantityInput.value;
            }
        }
    }
    
    // Listen for quantity changes on main product form
    const mainQuantityInput = document.querySelector('.pvGroup-row .quantity__input, .productView-form .quantity__input');
    
    if (mainQuantityInput) {
        // Sync on input change
        mainQuantityInput.addEventListener('change', syncQuantityToSticky);
        
        // Also sync when plus/minus buttons are clicked
        const quantityContainer = mainQuantityInput.closest('.quantity__container, .quantity__group');
        if (quantityContainer) {
            const buttons = quantityContainer.querySelectorAll('.btn-quantity');
            buttons.forEach(button => {
                button.addEventListener('click', function() {
                    // Wait a moment for the value to update
                    setTimeout(syncQuantityToSticky, 100);
                });
            });
        }
        
        // Initial sync
        syncQuantityToSticky();
    }
    
    // Before sticky cart form submission, ensure quantity is synced
    const stickyForms = document.querySelectorAll('.productView-stickyCart form');
    stickyForms.forEach(form => {
        form.addEventListener('submit', function(e) {
            // Sync quantity before submission
            syncQuantityToSticky();
            
            // Create or update quantity input in sticky form
            let quantityInput = this.querySelector('input[name="quantity"]');
            const mainQuantity = document.querySelector('.pvGroup-row .quantity__input, .productView-form .quantity__input');
            
            if (mainQuantity) {
                if (!quantityInput) {
                    // Create hidden quantity input if it doesn't exist
                    quantityInput = document.createElement('input');
                    quantityInput.type = 'hidden';
                    quantityInput.name = 'quantity';
                    this.appendChild(quantityInput);
                }
                quantityInput.value = mainQuantity.value || 1;
            }
        });
    });
});
